import { APP_META_TRAVEL_ADS_API_ENDPOINT } from "constants/api_urls";
import axios from "axios";
import { getUserToken } from "utils/functions/userToken";

export const getMediaLibrary = async (hotelId) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.get(
            `${APP_META_TRAVEL_ADS_API_ENDPOINT}/api/meta-ads/media-library/${hotelId}`,
            {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.errorMessage || "Failed to fetch media library";
        return { success: false, error: errorMessage };
    }
};

export const addMediaLibraryPost = async (hotelId, medias) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.post(
            `${APP_META_TRAVEL_ADS_API_ENDPOINT}/api/meta-ads/media-library`,
            {
                hotel_id: hotelId,
                media_entries: medias,
            },
            {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.errorMessage || "Failed to add to media library";
        return { success: false, error: errorMessage };
    }
};